let copySource = {
    document: {
        title:'Acheter/Donner des points'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Achetez des Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=fr-FR&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=fr-FR&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Offrez des Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=fr-FR&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=fr-FR&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Multipliez points',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=fr-FR&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=fr-FR&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.fr/default.mi'
        },
    },
    hero: {
        lang: 'landing-fr',
        headline: {
            lineOne: 'Des points pour\n satisfaire vos envies. ',
            lineTwo: "Achetez maintenant, partez\n quand bon vous semble.",
        },
        subHeadline : "Vous avez l'inspiration, il ne vous manque plus que\n les points. Qu'il s'agisse d’une découverte\n gratifiante ou d'une expérience impromptue, il y a\n d'innombrables choses à visiter et à faire. Achetez\n ou offrez des points.",
        alt: 'Foncez sur les Points et Partez en Voyage. Réservez un voyage de rêve. Passez plus de nuits en soirée. C’est l’Année du Toujours Plus - et tout cela est possible avec les points Marriott Bonvoy®.'
    },
    promo: {
        hero: {
            promoLang: 'promo-fr',
            headline: "Wonders of More",
            body:"Get closer to your next vacation with a 50% bonus on purchases of 2,000 or more points October 6–13.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Fenêtre d\'une chambre d\'hôtel intérieure donnant sur le paysage urbain.',
            header:'Achetez des Points',
            copy:"Que vous souhaitiez séjourner une nuit supplémentaire ou profiter\n d'un accès VIP à un spectacle à guichets fermés, achetez des\n points dès maintenant afin d'être prêt, quelle que soit l'occasion.",
            linkCopy:'ACHETEZ DES POINTS',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=fr-FR&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=fr-FR&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'Balcon d\'hôtel avec piscine donnant sur l\'océan.',
            header:'Offrez des Points',
            copy:"Offrez des points à vos proches afin qu'ils puissent voyager quand\n (et où) bon leur semble.",
            linkCopy:'OFFREZ DES POINTS',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=fr-FR&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=fr-FR&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Multipliez points',
            copy:"Vous avez gagné des points lors d'un séjour récent ? Vous pouvez désormais acheter jusqu'à 4 fois plus de points à un tarif réduit.",
            linkCopy:'ACHETEZ DES POINTS ET FAITES DES ÉCONOMIES',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=fr-FR&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=fr-FR&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Devenez Membre',
            link: 'https://www.marriott.com/fr/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Accédez aux Tarifs Membres, aux points pour des nuits gratuites et plus encore.Les nouveaux membres peuvent acheter des points trente (30) jours après avoir adhéré au programme Marriott Bonvoy.'
        }
    },
    footer:{
        copyrightOne:'Ce site Web est géré par Points.com Inc. au nom de Marriott International, Inc. pour l’achat de Marriott Bonvoy Points conformément aux ',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-FR-FR.html',
        copyrightTwo:'conditions générales de Points.com Inc.',
        copyrightThree:'. L’attribution et l’utilisation de Marriott Bonvoy Points dans le cadre d’une transaction d’achat sont soumises au ',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour:'règlement du programme Marriott Bonvoy',
        copyrightFive:' et à sa ',
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix:'politique de confidentialité',
        copyrightSeven:'.',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'Français',
        tracking:{
            doNotSell:{
                copy:'Ne Vendez Pas Mes Informations Personnelles',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Préférences de Suivi',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Conditions d’Utilisation',
            href:'https://www.marriott.fr/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Conditions Générales du Programme',
            href:'https://www.marriott.fr/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Centre de Confidentialité',
            href:'https://www.marriott.fr/a-propos/declaration-de-confidentialite-france.mi'
        },
        accessibility:{
            copy:'Accessibilité Numérique',
            href:'https://www.marriott.fr/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Plan du Site',
            href:'https://www.marriott.fr/sitemap.mi'
        },
        help:{
            copy:'Aide',
            href:'https://www.marriott.fr/help/default.mi'
        },
    }

}

export default copySource
